import React from "react";
import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Left-anchored by default (mr-auto). If true, centers the content (mx-auto).
   */
  center?: boolean;
  /**
   * Tailwind max-width utility. Defaults to 1400px custom value.
   */
  maxWidthClassName?: string; // e.g., "max-w-[1320px]", "max-w-[1400px]"
  /**
   * Apply vertical padding. Defaults to pt-8 pb-6.
   */
  withVerticalPadding?: boolean;
}

export function PageContainer({
  children,
  className,
  center = false,
  maxWidthClassName = "max-w-[960px]",
  withVerticalPadding = true,
}: PageContainerProps) {
  return (
    <div className={cn(
      "w-full px-4 md:px-6",
      withVerticalPadding && "pt-8 pb-6",
      className
    )}>
      <div
        className={cn(
          center ? "mx-auto" : "mr-auto",
          "w-full",
          maxWidthClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
